import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { BillCard, LoadingFit } from '../../../share/Components'
import { RaytebForm, TextBox } from '../../../share/Elements'
import { useState, useEffect } from 'react'

type InputType = {
  Year: number
  Month: number
}
const ListBill = ({ centerId, token }) => {
  const [inputBill, setInputBill] = useState<InputType>({
    Year: parseInt(new Date().toShamsi().split('/')[0].toEnglish()),
    Month: parseInt(new Date().toShamsi().split('/')[1].toEnglish()),
  })
  const listBill = useFetch<Array<BillViewModel>, BillInputModel>({
    request: RaytebRequests.IHIO_GetListBill_POST({
      headers: { centerId },
      token,
    }),
  })
  useEffect(() => {
    listBill.reFetch({
      month: inputBill.Month,
      year: inputBill.Year,
    })
  }, [])
  return (
    <div className='py-2'>
      <LoadingFit isLoading={listBill.isLoading} fixed={true} />
      <RaytebForm
        checkIsRequired={true}
        className='relative md:max-w-md md:mx-auto px-4'
        onSubmit={(e) => {
          listBill.reFetch({
            month: e.target['month'].value,
            year: e.target['year'].value,
          })
        }}
      >
        <div className='px-4 mt-5 grid grid-cols-10 gap-3 '>
          <div className='col-span-5'>
            <TextBox
              innerText='سال'
              Type={TextBoxTypeEnum.Number}
              name='year'
              Regular='^1+([3-4])+([0-9]{2})$'
              RxgMessage='سال باید بین 1300 تا 1499 باشد'
              onChange={(e) => {
                document.getElementById('submitFormBill')?.click()
                setInputBill({ ...inputBill, Year: e.target.value })
              }}
              value={inputBill.Year.toString()}
              isRequired={true}
            />
          </div>
          <div className='col-span-5'>
            <TextBox
              innerText='ماه'
              Type={TextBoxTypeEnum.Number}
              name='month'
              Regular='^(0?[1-9]|1[012])$'
              RxgMessage='ماه باید بین 1 تا 12 باشد'
              onChange={(e) => {
                document.getElementById('submitFormBill')?.click()
                setInputBill({
                  ...inputBill,
                  Month: e.target.value,
                })
              }}
              value={inputBill.Month.toString()}
              isRequired={true}
            />
          </div>
        </div>
        <div className='px-4 mt-5 grid grid-cols-10 gap-3 md:gap-4 items-center justify-center content-center'></div>
        <input id='submitFormBill' type='submit' className='hidden' />
      </RaytebForm>
      <div className='grid grid-cols-1 px-1'>
        {listBill.result?.map((n, i) => (
          <BillCard key={i} model={n} />
        ))}
      </div>
    </div>
  )
}

export default ListBill
